<template>
 <div>
  <div v-if="this.api.getCookies('login') === 'true' || this.api.getCookies('login') === true"> 
    <Splitter style="border:none;" >
      <SplitterPanel :minSize="50" >
        <div class="order-status">
          <div v-tooltip.right="`${this.t('sentence.progress0Tooltip')}`">{{ $t('menu.progress0') }}
          </div>
          <span class="order-count">
            <span v-if="this.api.getCookies('page') === 'list'">
              <a @click="setOrder(0, val0)" class="link">{{ val0 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else-if="this.api.getCookies('page') === 'forwarder'">
              <a @click="setForwarder(0)" class="link">{{ val0 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else>
              <a @click="phref(0, val0)" class="link">{{ val0 }}</a> {{ $t('unit.quantity') }}
            </span>
          </span>
        </div>
        <div class="order-status">
          <div v-tooltip.right="`${this.t('sentence.progress2Tooltip')}`">{{ $t('menu.progress2') }}</div>
          <span class="order-count">
            <span v-if="this.api.getCookies('page') === 'list'">
              <a @click="setOrder(2, val2)" class="link">{{ val2 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else-if="this.api.getCookies('page') === 'forwarder'">
              <a @click="setForwarder(2)" class="link">{{ val2 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else>
              <a @click="phref(2, val2)" class="link">{{ val2 }}</a> {{ $t('unit.quantity') }}
            </span>
          </span>
        </div>
        <div class="order-status">
          <div v-tooltip.right="`${this.t('sentence.progress4Tooltip')}`">{{ $t('menu.progress4') }}</div>
          <span class="order-count">
            <span v-if="this.api.getCookies('page') === 'list'">
              <a @click="setOrder(4, val4)" class="link">{{ val4 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else-if="this.api.getCookies('page') === 'forwarder'">
              <a @click="setForwarder(4)" class="link">{{ val4 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else>
              <a @click="phref(4, val4)" class="link">{{ val4 }}</a> {{ $t('unit.quantity') }}
            </span>
          </span>
        </div>
        <div class="order-status">
          <div v-tooltip.right="`${this.t('sentence.progress6Tooltip')}`">{{ $t('menu.progress6') }}</div>
          <span class="order-count">
            <span v-if="this.api.getCookies('page') === 'list'">
              <a @click="setOrder(6, val6)" class="link">{{ val6 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else-if="this.api.getCookies('page') === 'forwarder'">
              <a @click="setForwarder(6)" class="link">{{ val6 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else>
              <a @click="phref(6, val6)" class="link">{{ val6 }}</a> {{ $t('unit.quantity') }}
            </span>
          </span>
        </div>
        <div class="order-status">
          <div v-tooltip.right="`${this.t('sentence.progress-1Tooltip')}`">{{ $t('menu.progress-1') }}</div>
          <span class="order-count">
            <span v-if="this.api.getCookies('page') === 'list'">
              <a @click="setOrder(-1, val8)" class="link">{{ val8 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else-if="this.api.getCookies('page') === 'forwarder'">
              <a @click="setForwarder(-1)" class="link">{{ val8 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else>
              <a @click="phref(-1, val8)" class="link">{{ val8 }}</a> {{ $t('unit.quantity') }}
            </span>
          </span>
        </div>
      </SplitterPanel>
      <SplitterPanel class="flex items-center justify-center" :minSize="50" >
        <div class="order-status">
          <div v-tooltip.right="`${this.t('sentence.progress1Tooltip')}`">{{ $t('menu.progress1') }}</div>
          <span class="order-count">
            <span v-if="this.api.getCookies('page') === 'list'">
              <a @click="setOrder(1, val1)" class="link">{{ val1 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else-if="this.api.getCookies('page') === 'forwarder'">
              <a @click="setForwarder(1)" class="link">{{ val1 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else>
              <a @click="phref(1, val1)" class="link">{{ val1 }}</a> {{ $t('unit.quantity') }}
            </span>
          </span>
        </div> 
        <div class="order-status">
          <div v-tooltip.right="`${this.t('sentence.progress3Tooltip')}`">{{ $t('menu.progress3') }}</div>
          <span class="order-count">
            <span v-if="this.api.getCookies('page') === 'list'">
              <a @click="setOrder(3, val3)" class="link">{{ val3 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else-if="this.api.getCookies('page') === 'forwarder'">
              <a @click="setForwarder(3)" class="link">{{ val3 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else>
              <a @click="phref(3, val3)" class="link">{{ val3 }}</a> {{ $t('unit.quantity') }}
            </span>
          </span>
        </div> 
        <div class="order-status">
          <div v-tooltip.right="`${this.t('sentence.progress5Tooltip')}`">{{ $t('menu.progress5') }}</div>
          <span class="order-count">
            <span v-if="this.api.getCookies('page') === 'list'">
              <a @click="setOrder(5, val5)" class="link">{{ val5 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else-if="this.api.getCookies('page') === 'forwarder'">
              <a @click="setForwarder(5)" class="link">{{ val5 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else>
              <a @click="phref(5, val5)" class="link">{{ val5 }}</a> {{ $t('unit.quantity') }}
            </span>
          </span>
        </div> 
        <div class="order-status">
          <div v-tooltip.right="`${this.t('sentence.progress7Tooltip')}`">{{ $t('menu.progress7') }}</div>
          <span class="order-count">
            <span v-if="this.api.getCookies('page') === 'list'">
              <a @click="setOrder(7, val7)" class="link">{{ val7 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else-if="this.api.getCookies('page') === 'forwarder'">
              <a @click="setForwarder(7)" class="link">{{ val7 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else>
              <a @click="phref(7, val7)" class="link">{{ val7 }}</a> {{ $t('unit.quantity') }}
            </span>
          </span>
        </div> 
        <div class="order-status">
          <div v-tooltip.right="`${this.t('sentence.progress-2Tooltip')}`">{{ $t('menu.progress-2') }}</div>
          <span class="order-count">
            <span v-if="this.api.getCookies('page') === 'list'">
              <a @click="setOrder(-2, val9)" class="link">{{ val9 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else-if="this.api.getCookies('page') === 'forwarder'">
              <a @click="setForwarder(-2)" class="link">{{ val9 }}</a> {{ $t('unit.quantity') }}
            </span>
            <span v-else>
              <a @click="phref(-2, val9)" class="link">{{ val9 }}</a> {{ $t('unit.quantity') }}
            </span>
          </span>
        </div>
      </SplitterPanel>
    </Splitter>
  </div>
  <login v-else @login="login" :border=true pageKey="dashboard" /> 
 </div>
</template>

<script>

import router from '../../router'
import login from '@/components/common/Login.vue'
import { useI18n } from 'vue-i18n'

export default {
  emits: ["login"],
  components: {
    login
  },
  setup() {
    const { t } = useI18n()
    return {
      t
    }
  },
  mounted() {
    this.emitter.on('distinct' + this.page, this.setOrder)
    this.emitter.on('refresh' + this.page, this.getOrderInfo)
  },
  unmounted() {
    this.emitter.off('distinct' + this.page, this.setOrder)
    this.emitter.off('refresh' + this.page, this.getOrderInfo)
  },
  props: {
    page:String,
    forwarderOrders:String
  },
  data() { 
    return { 
      name:undefined,
      range: 'r2',
      val0:'', val1:'', val2:'', val3:'', val4:'', val5:'', val6:'', val7:'', val8:'', val9:'',
    }
  },
  methods: {
    login() {
      this.$emit('login')
    },
    async getOrderInfo(param) {
      const id = this.api.getCookies('id')
      if(id) {
        this.emitter.emit('dialog', {flag:true})
        this.range = param.range
        const rangeResult = this.api.getRange(this.range)
        let p = {type:'SELECT_ORDER_STATUS_CNT', id: ""+id, startdate: rangeResult.startDate, enddate: rangeResult.endDate}
        if(this.api.getCookies('page') === 'forwarder' ) {
          p.type = 'SELECT_FORWARDER_ORDER_STATUS_CNT'
          // Test
          p.name = param.fName
        }
        await this.api.axiosGql(p.type, p)
        .then( async (res) => {
          const json = res.data
            // 주문접수(0)/입금대기(1)/입금완료(2)/구매완료(3)/입고대기(4)/창고도착(5)/배송중(6)/거래완료(7)/거래취소(8)/환불완료(9)
          this.val0 = json.ORDER_CHECK ? json.ORDER_CHECK.length : 0
          this.val1 = json.DEPOSIT_READY ? json.DEPOSIT_READY.length : 0
          this.val2 = json.DEPOSIT_CMPL ? json.DEPOSIT_CMPL.length : 0
          this.val3 = json.PURCHASE_CMPL ? json.PURCHASE_CMPL.length : 0
          this.val4 = json.WAREHOUSING ? json.WAREHOUSING.length : 0
          this.val5 = json.DELIVERY_READY ? json.DELIVERY_READY.length : 0
          this.val6 = json.DELIVERY_ING ? json.DELIVERY_ING.length : 0
          this.val7 = json.TRANSACTION_CMPL ? json.TRANSACTION_CMPL.length : 0
          this.val8 = json.TRANSACTION_CNCL ? json.TRANSACTION_CNCL.length : 0
          this.val9 = json.REFUND_CMPL? json.REFUND_CMPL.length : 0
        })
        .catch( (err) => {
          console.log(err)
        })
        .finally(()=> {
          this.emitter.emit('dialog', {flag:false})
        })
      }
    },
    async setOrder(status, cnt) {
      if(cnt !== 0) {
        this.emitter.emit('dialog', {flag:true})
        let rangeJson = this.api.getRange(this.range)
        await this.api.axiosGql('SELECT_DISTINCT_ORDER_LIST', {type:'SELECT_DISTINCT_ORDER_LIST', id: "" + this.api.getCookies('id'), startdate: rangeJson.startDate, enddate: rangeJson.endDate, status: status, page: 1})
        .then( async (res) => {
          const json = res.data
          for(var i = 0; i < json.length; i++) {
            let order = json[i]
            const country = order.COUNTRY
            if(!order.COUNTRY2) order.COUNTRY2 = `${this.t('country.KR')}`
            let currency = this.api.getCurrency(country)

            order.ORIGIN_PRICE = order.ORIGIN_PRICE + currency
            let tmpStatus = order.STATUS

            if(tmpStatus !== undefined) order.STATUS = this.api.getOrderStatus(tmpStatus)

            let invoiceNumber = order.INVOICE_NUMBER
            let deliveryKrCompany = order.DELIVERY_KR_COMPANY

            if(invoiceNumber !== undefined && deliveryKrCompany !== undefined && (tmpStatus === 6 || tmpStatus === 7) ) order.INVOICE_NUMBER = this.api.getDeliveryUrl(invoiceNumber, deliveryKrCompany)
          }
          this.$emit("setOrder", res.data, status)
        })
        .catch( (err) => {
          console.log(err)
        })
        .finally( ()=> {
          this.emitter.emit('dialog', {flag:false})
        })
      } else {
        this.$notify(this.api.getOrderStatus(status) + `${this.t('sentence.noResult2')}`)
      }
    },
    async phref(type, cnt) {
      if(cnt === 0) {
        this.$notify(this.api.getOrderStatus(type) + `${this.t('sentence.noResult2')}`)
      } else {
        this.emitter.emit('dialog', {flag:true})
        let rangeJson = this.api.getRange(this.range)
        // IDX, STATUS, NAME, COUNTRY, URL, IMG_URL, SELL_PRICE, ORIGIN_PRICE, ORDER_DATE, TRACKING_NUMBER, INVOICE_NUMBER, DELIVERY_KR_COMPANY
        await this.api.axiosGql('SELECT_DISTINCT_ORDER_LIST', {type:'SELECT_DISTINCT_ORDER_LIST', id: "" + this.api.getCookies('id'), startdate: rangeJson.startDate, enddate: rangeJson.endDate, status: type, page: 1})
        .then( async (res) => {
          let orderArray = new Array()
          res.data.map(order => {
            const country = order.COUNTRY
            // const found = (this.api.COUNTRIES || []).find(c => c.name === country)
            // let currency = found ? ` ${found.currency}` : ' EUR'
            let currency = this.api.getCurrency(country)
            order.ORIGIN_PRICE = order.ORIGIN_PRICE + currency
            if(!order.COUNTRY2) order.COUNTRY2 = `${this.t('country.KR')}`
            
            order.range = this.range
            orderArray.push(JSON.stringify(order))
          })
          router.push({name:"list", params: orderArray})
        })
        .catch( (err) => {
          console.log(err)
        }) 
        .finally( ()=> {
          this.emitter.emit('dialog', {flag:false})
        })
      }
    },
    setForwarder(type) {
      this.emitter.emit('forwarderReload', `clickDashboard:${type}`)
    },
    forwarderDashBoard() {
      this.val0 = this.val1 = this.val2 = this.val3 = this.val4 = this.val5 = this.val6 = this.val7 = this.val8 = this.val9 = 0
      for(var i = 0; i < this.forwarderOrders.length; i++) {
        switch (this.forwarderOrders[i].STATUS) {
          case 0:
            this.val0++
            break
          case 1:
            this.val1++
            break
          case 2:
            this.val2++
            break
          case 3:
            this.val3++
            break
          case 4:
            this.val4++
            break
          case 5:
            this.val5++
            break
          case 6:
            this.val6++
            break
          case 7:
            this.val7++
            break
          case -1:
            this.val8++
            break
          case -2:
            this.val9++
            break
        }
      }
    },
  }
}
</script>

<style scoped>
.order-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px;
}

.order-count {
  margin-left: auto;
}
.order-count > span > a {
  color:red;
  font-weight: bold;
}
</style>